import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular.module('bcmModule')
        .factory('bcmResponsibilityService', ['$http', '$q', 'bcmService', function ($http, $q, bcmService) {

            var baseUrl = environment.apiUrl + '/Pilot/api/BIAProfile';

            function returnData(response) {
                return response.data;
            }

            return {

                // Create BCM Responsibility
                createBCMResponsibility: function (biaProfileId, bcmResponsibility) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/BCMResponsibility';

                    return $http
                        .post(reqUrl, bcmResponsibility)
                        .then(returnData);
                },

                // Update BCM Responsibility
                updateBCMResponsibility: function (bcmResponsibilityId, bcmResponsibility) {
                    var reqUrl = baseUrl + '/BCMResponsibility/' + bcmResponsibilityId;

                    return $http
                        .put(reqUrl, bcmResponsibility)
                        .then(returnData);
                }
            };
        }]);
})();
